<template>
  <fragment>
    <c-404-hero class="illustration-section-01" />
  </fragment>
</template>

<script>
import CLayout from '@/layouts/LayoutDefault.vue';
import C404Hero from '@/components/sections/404Hero.vue';

export default {
  name: '404',
  components: {
    C404Hero
  },
  created() {
    this.$emit('update:layout', CLayout);
  }
};
</script>
